<template>
  <div class="app-container">
    <el-dialog title="提示" :visible.sync="disagreeVisible" width="600px">
      <div style="margin:0px 0 20px;color:#000">请输入驳回原因</div>

      <el-form ref="form" :model="form" label-position="left" label-width="0">
        <el-form-item
          prop="content"
          :rules="[
            { required: true, message: '请输入驳回内容', trigger: 'blur' },
          ]"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 20 }"
            v-model="form.content"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="disagreeVisible = false">取 消</el-button>
        <el-button type="primary" @click="disagree">确 定</el-button>
      </span>
    </el-dialog>

    <div
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <el-row type="flex">
        <el-button
          type="warning"
          :loading="tableLoading"
          icon="el-icon-upload2"
          @click="exportExcel"
          >导出Excel</el-button
        >
        <el-button
          class="filter-item"
          :disabled="ids.length <= 0"
          type="success"
          icon="el-icon-check"
          size="small"
          @click="batchAgree"
          >批量通过
        </el-button>
        <el-button
          class="filter-item"
          :disabled="ids.length <= 0"
          type="success"
          icon="el-icon-check"
          size="small"
          @click="batchDisagree"
          >批量驳回
        </el-button>
        <el-button
          class="filter-item"
          type="success"
          icon="el-icon-check"
          size="small"
          @click="batchSignInHandler"
          >一键发放积分
        </el-button>
      </el-row>

      <el-row type="flex" justify="end">
        <div style="margin-right: 10px;">
          <el-select
            v-model="listQuery.questionnaire_state"
            placeholder="填写状态"
            clearable
          >
            <el-option label="未填写" :value="0" />
            <el-option label="已填写" :value="1" />
          </el-select>
        </div>
        <div style="margin-right: 10px;">
          <el-select v-model="listQuery.state" placeholder="审核状态" clearable>
            <el-option label="待审核" :value="0" />
            <el-option label="审核驳回" :value="-1" />
            <el-option label="审核通过" :value="1" />
            <el-option label="已签到" :value="2" />
            <el-option label="已发放积分" :value="3" />
          </el-select>
        </div>
        <el-input
          style="max-width:210px;"
          v-model="listQuery.name"
          placeholder="用户名"
        ></el-input>
        <el-button
          style="margin-left:12px;"
          type="primary"
          icon="el-icon-search"
          :loading="tableLoading"
          @click="onFilte"
          >查询</el-button
        >
      </el-row>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        :loading="tableLoading"
        fit
        highlight-current-row
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="isselectable">
        </el-table-column>
        <el-table-column type="index" label="序号" width="110" align="center" />

        <el-table-column
          prop="user_info.head_img"
          label="头像"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <el-image style="width: 60px; height: 60px" :src="scope.row.user_info.head_img" fit="cover" /> -->
            <img
              style="width:60px; height: 60px;object-fit: cover;"
              :src="scope.row.user_info.head_img"
              alt="用户头像"
            />
          </template>
        </el-table-column>

        <el-table-column
          prop="user_info.name"
          label="昵称"
          min-width="95"
          align="center"
        />

        <template v-if="tableData.length">
          <el-table-column
            v-for="(item, index) in tableData[0].activity_condition"
            :key="index"
            :prop="`activity_condition[${index}].content`"
            :label="item.name"
            min-width="95"
            align="center"
          />
        </template>
        <el-table-column label="填写状态" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.questionnaire_id" type="success"
              >已填写</el-tag
            >
            <el-tag v-else type="danger">未填写</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" min-width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 0" type="warning">待审核</el-tag>
            <el-tag v-else-if="scope.row.state === -1" type="danger"
              >审核驳回</el-tag
            >
            <el-tag v-else-if="scope.row.state === 1" type="success"
              >审核通过</el-tag
            >
            <el-tag v-else-if="scope.row.state === 2" type="primary"
              >已签到</el-tag
            >
            <el-tag v-else-if="scope.row.state === 3" type="success"
              >已发放积分</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="reject"
          label="驳回原因"
          min-width="300"
          align="center"
        />

        <el-table-column
          prop="application_number"
          label="申请次数"
          min-width="300"
          align="center"
        />

        <el-table-column
          prop="created_at"
          label="报名时间"
          min-width="95"
          align="center"
        />

        <el-table-column
          prop="user_info.head_img"
          label="操作"
          width="300"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="agreeHandler(scope.row)"
              v-if="scope.row.state === 0"
              >通过</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="disagreeHandler(scope.row)"
              v-if="scope.row.state === 0"
              >驳回</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-else-if="scope.row.state === 1"
              @click="signInHandler(scope.row.id)"
              >签到</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="is_grant_integral === 1 && scope.row.state === 2"
              @click="grantHandler(scope.row.id)"
              >发放积分</el-button
            >
            <el-button
              type="success"
              size="mini"
              style="margin-top: 10px;"
              v-if="scope.row.questionnaire_id && scope.row.questionnaire_log"
              @click="checkUserQuestionnaire(scope.row)"
              >查看问卷</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <QuestionnaireDetailModal
      v-if="questionnaireVisible"
      :show.sync="questionnaireVisible"
      :detailData="modalData"
    />
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 查看报名
import QuestionnaireDetailModal from './components/QuestionnaireDetailModal.vue'
import { questionnaire } from '@/api/order'
import {
  registryList,
  registryExamine,
  registryBatchExamine,
  registryBatchSignIn,
  signIn,
  grant,
  exportActivityExcel,
} from '@/api/activity'
import * as XLSX from 'xlsx'
import store from '@/store'
import { review } from '@/api/review'
export default {
  data: () => ({
    form: {
      content: '',
    },
    ids: [],
    is_grant_integral: '',
    disagreeVisible: false,
    questionnaireTemplate: null,
    curObj: {},
    reject: '',
    tableData: [],
    tableLoading: false,
    listQuery: {
      page: 1,
      limit: 10,
      name: '',
    },
    total: null,
    questionnaireVisible: false,
    modalData: null,
  }),
  components: { QuestionnaireDetailModal },
  props: {
    id: String | Number,
    title: String,
  },
  methods: {
    //一键发放积分
    async batchSignInHandler() {
      let data = {
        activity_id: this.id,
      }
      this.$confirm(`此操作将一键发放积分, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        registryBatchSignIn(data).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    //批量驳回
    async batchDisagree() {
      if (this.ids.length <= 0) {
        this.$message({
          message: '请选择数据',
          type: 'warning',
        })
        return
      }
      this.disagreeVisible = true
    },
    //批量通过
    async batchAgree() {
      if (this.ids.length <= 0) {
        this.$message({
          message: '请选择数据',
          type: 'warning',
        })
        return
      }
      let data = {
        ids: this.ids,
        type: '1',
      }
      this.$confirm(`此操作将批量通过审核, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        registryBatchExamine(data).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    isselectable(row) {
      if (row.state == 0 || row.state == 1 || row.state == 2) {
        return row
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.ids = val.map((item) => item.id)
    },
    async getTemplate(id) {
      const { data } = await questionnaire.questionnaireTemplate(id)
      this.questionnaireTitle = data.title
      this.questionnaireTemplate = data.template
      console.log(data)
    },
    checkUserQuestionnaire(data) {
      this.modalData = data
      this.questionnaireVisible = true
    },
    async getList() {
      this.tableLoading = true
      this.tableData = []
      const { data } = await registryList({ id: this.id, ...this.listQuery })

      this.tableData = data.data
      this.total = data.total
      this.tableLoading = false
    },
    onFilte() {
      this.listQuery.page = 1
      this.getList()
    },
    // 导出Excel
    async exportExcel() {
      console.log('exportExcel')
      // +++修改excel-活动列表-查看报名-附件7---ok
      const { total } = this
      if (!total) return

      try {
        const {
          data: { data: reqData },
        } = await exportActivityExcel({
          ...this.listQuery,
          page: 1,
          limit: 99999999999,
          id: this.id,
        })
        console.log(reqData)
        var wb = XLSX.utils.book_new()

        var excelData = [
          [
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ...reqData[0].activity_condition.map((item, index) =>
              index === 0 ? '报名信息' : ''
            ),
          ],
          [
            '报名序号',
            '用户名',
            '性別',
            '年龄',
            '手机号',
            '居住地-国家',
            '居住地-省份',
            '微信ID',
            '邮箱',
            '擅长领域',
            '活动名称',
            '报名时间',
            '申请次数',
            '活动状态',
            '招募时间',
            '进行时间',
            '结束时间',
            '获得积分',
            '权重',
            '状态',
            ...reqData[0].activity_condition.map((item) => item.name),
            ...(this.questionnaireTemplate
              ? this.questionnaireTemplate.map((item) => item.name)
              : []),
          ],
          ...reqData.map((item, index) => [
            index + 1,
            item.user_info.name,
            item.user_info.gender === 1
              ? '男性'
              : item.user_info.gender === 2
              ? '女性'
              : '未设置',
            item.user_info.age_group === 1
              ? '20岁以下'
              : item.user_info.age_group === 2
              ? '21~30岁'
              : item.user_info.age_group === 3
              ? '31~40岁'
              : item.user_info.age_group === 4
              ? '41~50岁'
              : item.user_info.age_group === 5
              ? '51岁以上'
              : '未设置',
            item.user_info.account,
            item.user_info.country,
            item.user_info.provinces,
            item.user_info.wx_id,
            item.user_info.email,
            item.user_info.evaluation_type_field.length > 0
              ? item.user_info.evaluation_type_field
                  .map((item) => item.name)
                  .join(',')
              : '',
            item.activity_info.title,
            item.created_at,
            item.application_number, // 申请次数
            item.activity_info.activity_state === 1
              ? '准备中'
              : item.activity_info.activity_state === 2
              ? '招募中'
              : item.activity_info.activity_state === 3
              ? '进行中'
              : item.activity_info.activity_state === 4
              ? '已结束'
              : item.activity_info.activity_state === 5
              ? '已取消'
              : '无字段',
            item.activity_info.recruit_at,
            item.activity_info.start_at,
            item.activity_info.end_at,
            item.activity_info.integarl_num,
            item.activity_info.sort,
            item.activity_info.state ? '正常' : '已下架',
            ...item.activity_condition.map(
              (activityItem) => activityItem.content
            ),
            ...(item.questionnaire_log
              ? this.questionnaireTemplate.map((questionItem, qIndex) => {
                  const answer = item.questionnaire_log[questionItem.id]
                  if (questionItem.type === 1 || questionItem.type === 3) {
                    if (
                      questionItem.option.length > 0 &&
                      questionItem.option[0] &&
                      typeof answer === 'number'
                    ) {
                      return questionItem.option[answer]
                    } else {
                      return answer || ''
                    }
                  } else if (questionItem.type === 2) {
                    return answer ? answer.join(',') : ''
                  } else if (questionItem.type === 4) {
                    return answer
                      ? `附件（${answer.map((item) => item.path)}）`
                      : ''
                  } else {
                    return answer || ''
                  }
                })
              : []),
          ]),
        ]

        var ws = XLSX.utils.aoa_to_sheet(excelData)

        // 定义合并的范围
        const mergeCells = [{ s: { r: 0, c: 20 }, e: { r: 0, c: 22 } }] //索引从0开始;

        // 设置合并的单元格
        ws['!merges'] = mergeCells

        XLSX.utils.book_append_sheet(wb, ws, '报名列表')
        XLSX.writeFile(wb, `${this.title}报名列表.xlsx`)

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...',
        })
      } catch {
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!',
        })
      }
    },
    // 分页操作
    handleSizeChange(limit) {
      this.listQuery.limit = limit
      this.getList()
    },
    handleCurrentChange(page) {
      this.listQuery.page = page
      this.getList()
    },
    agreeHandler(scope) {
      let data = {
        id: scope.id,
        type: '1',
      }
      this.$confirm(
        `此操作将通过“${scope.user_info.name}”的审核, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(async () => {
        registryExamine(data).then(() => {
          this.getList()
          this.$message({
            message: '操作成功!',
            type: 'success',
          })
        })
      })
    },
    disagreeHandler(scope) {
      this.curObj = scope
      this.disagreeVisible = true
    },
    disagree() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.ids.length > 0) {
            let data = {
              ids: this.ids,
              type: '2',
              reject: this.form.content,
            }
            registryBatchExamine(data).then(() => {
              this.disagreeVisible = false
              this.getList()
              this.$message({
                message: '操作成功!',
                type: 'success',
              })
            })
          } else {
            let data = {
              id: this.curObj.id,
              type: '2',
              reject: this.form.content,
            }
            registryExamine(data).then(() => {
              this.disagreeVisible = false
              this.getList()
              this.$message({
                message: '操作成功!',
                type: 'success',
              })
            })
          }
        }
      })
    },
    signInHandler(id) {
      signIn({ id }).then(() => {
        this.getList()
        this.$message({
          message: '操作成功!',
          type: 'success',
        })
      })
    },
    grantHandler(id) {
      this.$confirm(`此操作将发放积分, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        grant({ id }).then(() => {
          this.getList()
          this.$message({
            message: '已发放积分!',
            type: 'success',
          })
        })
      })
    },
  },
  async created() {
    await this.getList()
    if (this.tableData.length > 0) {
      this.tableData.map((item) => {
        if (item.questionnaire_id) {
          this.getTemplate(item.questionnaire_id)
          return
        }
      })
    }
    this.is_grant_integral = store.getters.is_grant_integral
  },
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 12px;
}
</style>
